import React from 'react';
import PropTypes from 'prop-types';
import AuthLayout from './routes/Auth';
import UserLayout from './routes/Layout';
import MobileLayout from './routes/MobileLayout';

import ForgetPasswordPage from './components/auth/ForgetPassword';
import LoginPage from './components/auth/Login';
import ResetPasswordPage from './components/auth/ResetPassword';

import Dashboard from './components/Dashboard';

import InventoryViewPage from './components/inventories/InventoryView';
import InventoryListPage from './components/inventories/InventoryList';
import InvenotryEditPage from './components/inventories/InventoryEdit';

import OrderViewPage from './components/orders/OrderView';
import OrderListPage from './components/orders/OrderList';
import OrderEditPage from './components/orders/OrderEdit';

import RelationEditPage from './components/relations/RelationEdit';
import RelationListPage from './components/relations/RelationList';
import RelationViewPage from './components/relations/RelationView';

import ShipmentCreationPage from './components/shipments/ShipmentCreation';
import ShipmentViewPage from './components/shipments/ShipmentView';
import ShipmentListPage from './components/shipments/ShipmentList';
import ReturnCreationPage from './components/shipments/ReturnCreation';
import QbTransactionListPage from './components/shipments/QbTransactionList';

import WarehouseSettingPage from './components/settings/Warehouse';
import WarehouseShowPage from './components/settings/WarehouseShow';

import UserSettingPage from './components/settings/User';
import UserViewPage from './components/settings/UserShow';

import IntegrationLogPage from './components/settings/IntegrationLog';
import QbConfigPage from './components/settings/QbConfig'

import ReportPage from './components/reports/report'
import ProfilePage from './components/settings/ProfileShow'

import MobileOrderEdit from './components/mobile/MobileOrderEdit'
import MobileOrderListPage from './components/mobile/MobileOrderList'
import MobileOrderViewPage from './components/mobile/MobileOrderView'
import MobileShipmentCreationPage from './components/mobile/MobileShipmentCreation'

/*
  New Ecommerce Components Nov & Dec 2019
  SPR and Shopify
*/
import SprFile from './components/ecommerce/SprFile';
import SprProductList from './components/ecommerce/SprProductList'
import SprProductEdit from './components/ecommerce/SprProductEdit';

const App = ( props ) => <div>
  <AuthLayout {...props} path="/auth/login" exact component={LoginPage} />
  <AuthLayout {...props} path="/auth/forget-password" exact component={ForgetPasswordPage} />
  <AuthLayout {...props} path="/auth/reset-password/:token" exact component={ResetPasswordPage} />

  <UserLayout {...props} path="/" exact component={Dashboard} />
  <UserLayout {...props} path="/inventories/:params" exact component={InventoryListPage} />
  <UserLayout {...props} path="/inventories/:id/view" exact component={InventoryViewPage} />
  <UserLayout {...props} path="/inventories/:id/edit" exact component={InvenotryEditPage} />

  <UserLayout {...props} path="/customers/:params" exact component={RelationListPage} />
  <UserLayout {...props} path="/customers/:id/edit/:type" exact component={RelationEditPage} />
  <UserLayout {...props} path="/customers/:id/view/:type" exact component={RelationViewPage} />
  <UserLayout {...props} path="/vendors/:params" exact component={RelationListPage} />
  <UserLayout {...props} path="/vendors/:id/edit/:type" exact component={RelationEditPage} />
  <UserLayout {...props} path="/vendors/:id/view/:type" exact component={RelationViewPage} />

  <UserLayout {...props} path="/customer-orders/:params" exact component={OrderListPage} />
  <UserLayout {...props} path="/vendor-orders/:params" exact component={OrderListPage} />
  <UserLayout {...props} path="/customer-returns/:params" exact component={OrderListPage} />
  <UserLayout {...props} path="/vendor-returns/:params" exact component={OrderListPage} />
  <UserLayout {...props} path="/customer-orders/:id/view" exact component={OrderViewPage} />
  <UserLayout {...props} path="/vendor-orders/:id/view" exact component={OrderViewPage} />
  <UserLayout {...props} path="/customer-returns/:id/view" exact component={OrderViewPage} />
  <UserLayout {...props} path="/vendor-returns/:id/view" exact component={OrderViewPage} />
  <UserLayout {...props} path="/customer-orders/:id/edit" exact component={OrderEditPage} />
  <UserLayout {...props} path="/vendor-orders/:id/edit" exact component={OrderEditPage} />
  <UserLayout {...props} path="/customer-returns/:id/edit" exact component={OrderEditPage} />
  <UserLayout {...props} path="/vendor-returns/:id/edit" exact component={OrderEditPage} />

  <UserLayout {...props} path="/shipments/create/oid/:orderId" exact component={ShipmentCreationPage} />
  <UserLayout {...props} path="/shipments/:type/:id/view" exact component={ShipmentViewPage} />
  <UserLayout {...props} path="/shipments/:type/:params" exact component={ShipmentListPage} />
  <UserLayout {...props} path="/returns/:shipmentId/create" exact component={ReturnCreationPage} />
  <UserLayout {...props} path="/qb/transactions/:params" exact component={QbTransactionListPage} />

  <UserLayout {...props} path="/settings/warehouses/:params" exact component={WarehouseSettingPage} />
  <UserLayout {...props} path="/settings/warehouses/:id/show" exact component={WarehouseShowPage} />

  <UserLayout {...props} path="/settings/users/:params" exact component={UserSettingPage} />
  <UserLayout {...props} path="/settings/users/:id/show" exact component={UserViewPage} />

  <UserLayout {...props} path="/settings/ecommerce/spr" exact component={SprFile} />
  <UserLayout {...props} path="/settings/ecommerce/products/:params" exact component={SprProductList} />
  <UserLayout {...props} path="/settings/ecommerce/products/:id/edit" exact component={SprProductEdit} />

  <UserLayout {...props} path="/settings/integrations/:partner/:credentialId/:params" exact component={IntegrationLogPage} />
  <UserLayout {...props} path="/settings/mapping/:partner/:credentialId/:params/config" exact component={QbConfigPage} />
  <UserLayout {...props} path="/reports" exact component={ReportPage} />
  <UserLayout {...props} path="/profile" exact component={ProfilePage} />
  
  <MobileLayout {...props} path="/mobile/customer-orders/:params" exact component={MobileOrderListPage} />
  <MobileLayout {...props} path="/mobile/vendor-orders/:params" exact component={MobileOrderListPage} />
  <MobileLayout {...props} path="/mobile/customer-returns/:params" exact component={MobileOrderListPage} />
  <MobileLayout {...props} path="/mobile/vendor-returns/:params" exact component={MobileOrderListPage} />
  <MobileLayout {...props} path="/mobile/customer-orders/:id/view" exact component={MobileOrderViewPage} />
  <MobileLayout {...props} path="/mobile/vendor-orders/:id/view" exact component={MobileOrderViewPage} />
  <MobileLayout {...props} path="/mobile/customer-returns/:id/view" exact component={MobileOrderViewPage} />
  <MobileLayout {...props} path="/mobile/vendor-returns/:id/view" exact component={MobileOrderViewPage} />
  <MobileLayout {...props} path="/mobile/customer-orders/:id/edit" exact component={MobileOrderEdit} />
  <MobileLayout {...props} path="/mobile/vendor-orders/:id/edit" exact component={MobileOrderEdit} />
  <MobileLayout {...props} path="/mobile/customer-returns/:id/edit" exact component={MobileOrderEdit} />
  <MobileLayout {...props} path="/mobile/vendor-returns/:id/edit" exact component={MobileOrderEdit} />
  <MobileLayout {...props} path="/mobile/shipments/create/oid/:orderId" exact component={MobileShipmentCreationPage} />
</div>

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js